var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M0,0H7.14V1.19H0ZM0,2.86H7.14V4H0ZM0,7.14H5.71V5.71H0ZM15,5,13.93,3.93,10,7.86,7.86,5.71,6.79,6.79,10,10Z","fill":"#0b3e8a","fill-opacity":"0.2"}})}
var staticRenderFns = []

export { render, staticRenderFns }